<template>
    <div class="container">

        <div class="card ">
            <div class="card-header bg-info-light">
                Naujas pardavimas
            </div>
            <div class="card-body">
                <div class="form-row">
                    <div class="col-12 col-md-6">
                        <label for="eq_id">Įranga</label>
                        <v-select v-if="equipment" class="vue-select2s" id="eq_id" name="select2"
                                  :options="equipment" label="name"
                                  :model.sync="new_equipment"
                                  v-model="new_equipment"
                                  :searchable="true" language="en-US">
                        </v-select>
                    </div>
                    <div class="col-6 col-md-3">
                        <label for="eq_qty">Kiekis</label>
                        <input id="eq_qty" class="form-control" @keyup="enter_submit" v-model="new_equipment_qty" type="text">
                    </div>
                    <div class="col-6 col-md-3">
                        <label for="">&nbsp;</label>
                        <button @click="add_equipment_to_offer" class="form-control btn btn-outline-success">Pridėti</button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="form-row" v-for="(se, i) in selected_equipment">
                    <div @click="deleteSelected(i, se.price, se.quantity)" class="col-1">-</div>
                    <div class="col-11 col-md-6">{{ se.equipment_text }} -- {{ se.quantity }} vnt.</div>
                </div>

                <div class="form-row">
                    <div class="col-3">
                        <div class="form-group">
                            <label for="price">Suma</label>
                            <div class="input-group">
                                <input id="price" class="form-control" readonly type="text" v-model="price">
                                <div class="input-group-append">
                                    <div class="input-group-text">€</div>
                                </div>
                            </div>

                        </div>
                    </div>


                    <div class="col-3">
                        <!--<div class="form-group">-->
                            <label for="cust_id">Klientas</label>
                            <!--<div class="input-group">-->
                                <v-select  v-if="customers" class="" id="cust_id" name="select2"
                                           :options="customers" label="name"
                                           :model.sync="selected_customer"
                                           v-model="selected_customer"
                                           :searchable="true" language="en-US">
                                </v-select>
                            <!--</div>-->

                        <!--</div>-->
                    </div>
                </div>

            </div>
            <div class="card-footer">
                <button @click="store_sale" class="btn btn-outline-success">Sukurti</button>
            </div>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select';
    export default {
        name: "NewSale",
        props:['cid', 'uid'],
        components:{
            vSelect,
        },
        data() {
            return {
                customer_id: '',
                power:'',
                price: '',
                discount: 0,
                payment1: '',
                percent1: '',
                payment2: '',
                percent2: '',
                payment3: '',
                percent3: '',
                equipment: '',
                usage: '',
                new_equipment: '',
                new_equipment_qty: '',
                selected_equipment: [],
                total:'',
                user_id:'',
                customers: '',
                selected_customer: ''
            }
        },
        watch: {

        },
        mounted() {

            axios.get('/get_equipment').then(res => {
                this.equipment = res.data
            });
            axios.get('/get_customers').then(res => {
                this.customers = res.data
            });

        },
        created(){

        },
        methods: {
            add_equipment_to_offer() {
                this.selected_equipment.push({equipment_id:this.new_equipment.id, equipment_text:this.new_equipment.name, quantity: this.new_equipment_qty, price: this.new_equipment.price});
                this.price = Number(this.price) + ( Number(this.new_equipment.price) *  Number(this.new_equipment_qty) );
                // this.percent1 = this.percent3 = '';
                console.log(this.new_equipment.power);
                // if(this.new_equipment.power > 0 && this.new_equipment.equipment_type_id == 1){
                //     this.power = Number(this.power) + Number(this.new_equipment.power) * Number(this.new_equipment_qty);
                //     this.power  = this.power.toFixed(2);
                // }
                this.new_equipment_qty = '';
            },
            deleteSelected(i, price, quantity){
                this.selected_equipment.splice(i, 1);
                this.price = Number(this.price) - ( Number(price) *  Number(quantity) );
            },
            store_sale(){
               console.log(this._data);
               if(this.selected_customer.length == 0){ alert('Nėra kliento'); return; }

               this.total = Number(this.price) - Number(this.discount);
               this.customer_id = 1;
               this.user_id = this.$props.uid;
                this.customer_id = this.selected_customer.id;
               this.percent2 = (100 - this.percent1 - this.percent3);
               axios.post('/store_sale', this._data).then(res => {
                   console.log(res.data);
                   window.location.replace('/sale/'+ res.data.id)
               }).catch(error => {
                   let array =  {'msg': error.response.data.message};
                   axios.post('/mail_error', array).then(res =>{
                       console.log(res.data);
                   });
                   window.location.replace('/404');
               });
            },

            enter_submit(e){
                if(e.keyCode == 13){
                    console.log('enter');
                    this.add_equipment_to_offer();
                }

            }
        }
    }
</script>

<style scoped>

</style>